import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import Tabs from './tabs/index.md';
import InitializeSDK from '/src/pages/resources/initialize.md';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TabsBlock = makeShortcode("TabsBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "signal"
    }}>{`Signal`}</h1>
    <p>{`The Signal extension allows marketers to send a "signal" to their apps through the Adobe Experience Platform Mobile SDKs. This signal might tell the Mobile SDKs or the apps to complete tasks, such as send PII-labeled data, to trigger a postback to a third-party ad-network and open an app deep link or URL. To ensure that signals are sent or are activated, the marketers need to configure triggers and traits in the Data Collection UI.`}</p>
    <p>{`The Signal extension allows you to send postbacks to third-party endpoints and open URLs, such as web URLs or application deep links, when using rules actions in the Data Collection UI.`}</p>
    <p>{`To send PII data to external destinations, the `}<inlineCode parentName="p">{`PII`}</inlineCode>{` action can trigger the Rules Engine when certain triggers and traits match. When setting a rule, you can also set the `}<inlineCode parentName="p">{`PII`}</inlineCode>{` action for a Signal event. The `}<inlineCode parentName="p">{`collectPii`}</inlineCode>{` API can then be used to trigger the rule and send the PII data to a remote server.`}</p>
    <p>{`To get started with Signal extension, complete the following steps:`}</p>
    <ol>
      <li parentName="ol">{`Add the `}<strong parentName="li">{`Signal`}</strong>{` extension to your app.`}</li>
      <li parentName="ol">{`Define the necessary rules in the Data Collection UI.`}</li>
      <li parentName="ol">{`(Optional) When using Send PII actions in the Data Collection UI, implement the APIs to collect PII data and send it to the configured third party destination.`}</li>
    </ol>
    <p>{`For more information about creating and configuring a rule in the Data Collection UI, see `}<a parentName="p" {...{
        "href": "https://experienceleague.adobe.com/docs/experience-platform/tags/ui/rules.html"
      }}>{`Rules`}</a>{`.`}</p>
    <h2 {...{
      "id": "add-the-signal-extension-to-your-app"
    }}>{`Add the Signal extension to your app`}</h2>
    <h3 {...{
      "id": "include-signal-extension-as-an-app-dependency"
    }}>{`Include Signal extension as an app dependency`}</h3>
    <p>{`Add MobileCore and Signal extensions as dependencies to your project.`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="3" mdxType="TabsBlock" />
    <p>{`Kotlin`}<br />{`(Android)`}</p>
    <Tabs query="platform=android-kotlin&task=add" mdxType="Tabs" />
    <p>{`Groovy`}<br />{`(Android)`}</p>
    <Tabs query="platform=android-groovy&task=add" mdxType="Tabs" />
    <p>{`CocoaPods`}<br />{`(iOS)`}</p>
    <Tabs query="platform=ios-pods&task=add" mdxType="Tabs" />
    <h3 {...{
      "id": "initialize-adobe-experience-platform-sdk-with-signal-extension"
    }}>{`Initialize Adobe Experience Platform SDK with Signal Extension`}</h3>
    <p>{`Next, initialize the SDK by registering all the solution extensions that have been added as dependencies to your project with Mobile Core. For detailed instructions, refer to the `}<a parentName="p" {...{
        "href": "/client-sdks/src/pages/home/getting-started/get-the-sdk/#2-add-initialization-code"
      }}>{`initialization`}</a>{` section of the getting started page.`}</p>
    <p>{`Using the `}<inlineCode parentName="p">{`MobileCore.initialize`}</inlineCode>{` API to initialize the Adobe Experience Platform Mobile SDK simplifies the process by automatically registering solution extensions and enabling lifecycle tracking.`}</p>
    <InitializeSDK query="componentClass=TabsBlock" mdxType="InitializeSDK" />
    <h2 {...{
      "id": "implement-the-mobile-sdk-to-send-pii-data-to-external-destinations"
    }}>{`Implement the Mobile SDK to send PII data to external destinations`}</h2>
    <p>{`To send PII data to external destinations, the `}<inlineCode parentName="p">{`PII`}</inlineCode>{` action can trigger the Rules Engine when the configured triggers and traits match. When creating a rule, you can set the `}<inlineCode parentName="p">{`PII`}</inlineCode>{` action for a Signal event, so that `}<inlineCode parentName="p">{`collectPii`}</inlineCode>{` can trigger the rule and send the `}<inlineCode parentName="p">{`PII`}</inlineCode>{` data.`}</p>
    <p>{`For more information about `}<inlineCode parentName="p">{`collectPii`}</inlineCode>{` and its usage, see `}<a parentName="p" {...{
        "href": "../api-reference.md#collectpii"
      }}>{`collectPii`}</a>{`.`}</p>
    <p>{`For more information about how to configure the Signal postbacks in the Data Collection UI, see `}<a parentName="p" {...{
        "href": "rules-engine-integration.md"
      }}>{`Signal extension and Rules Engine integration`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      